export default "__VITE_ASSET__f481f2e6__"